export default "__VITE_ASSET__Cc$$ISkS__"